<template>
  <div class="tab-container">
    <app-spinner v-if="!page_loaded" />
    <v-client-table
      v-if="page_loaded"
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
    >
      <template #h__select>
        <label
          v-if="table.items.length"
          class="checkbox checkbox--table"
        >
          <input
            v-model="checked_all"
            type="checkbox"
            name="checked_all"
            ref="mainCh"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #select="{ row }">
        <label class="checkbox  checkbox--table">
          <input
            v-model="checked"
            type="checkbox"
            :value="row.id"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #full_name="{ row }">
        <div class="table-default__left">
          <router-link :to="{name: 'clients-detail', params: {id: row.id }}" class="table-default__link-border">
            {{ row.full_name }}
          </router-link>
        </div>
      </template>
      <template #transfers="{ row }">
        <span v-if="row.transport.departure.departure_no_transfer">{{  row.transport.departure.departure_no_transfer_reason.name }}</span>
        <button
          v-else
          @click="onShowTransfersModal(row.transfers.departure)"
          type="button"
          class="table-default__activity table-default__activity--adds table-default__activity--transfers-departure"
          :class="{
            'table-default__activity--active': row.transfers.departure.length,
            'table-default__activity--transfers-departure-arranged': row.transfers.departure[0]?.status?.code === 'arranged',
            'table-default__activity--transfers-departure-cancelled': row.transfers.departure[0]?.status?.code === 'cancelled',
            'table-default__activity--transfers-departure-requested': row.transfers.departure[0]?.status?.code === 'requested' || row.transfers.departure?.status?.code === 'need_amended'
          }"
        />
      </template>
      <template #departure_method="{ row }">
        <div class="table-default__controls">
          <span
            class="table-default__transport table-default__transport--departure"
            :class="{
            'table-default__transport--present': row.transport.departure?.departure_method,
            'table-default__transport--confirmed': row.transport.departure?.departure_confirmed,
            'table-default__transport--car': row.transport.departure?.departure_method?.code === 'car',
            'table-default__transport--bus': row.transport.departure?.departure_method?.code === 'bus',
            'table-default__transport--self': row.transport.departure?.departure_method?.code === 'self'
          }"
          ></span>
        </div>
      </template>
      <template #departure_date="{ row }">
        {{ row.transport.departure?.departure_date ? dateFormat(row.transport.departure.departure_date) : '-' }}
        {{ row.transport.departure?.departure_time ? row.transport.departure.departure_time : '' }}
      </template>
      <template #departure_company="{ row }">
        {{ row.transport.departure?.departure_company ? row.transport.departure.departure_company.name : '-' }}
      </template>
      <template #departure_flight_number="{ row }">
        <span
          v-if="row.transport.departure?.departure_flight_number"
          class="status-tag"
          :style="{ 'backgroundColor': row.transport.departure.departure_flight_domestic ? '#77b017' : '#5f5f5f' }"
        >
          {{ row.transport.departure.departure_flight_number }}
        </span>
        <span v-else>-</span>
      </template>
      <template #departure_ticket="{ row }">
        <div class="table-default__controls">
          <button
            v-if="row.transport.departure?.departure_ticket && row.transport.departure?.departure_ticket.file"
            @click="onDownloadTicket(row.transport.departure)"
            type="button"
          >
            <img src="@/assets/img/download-table-blue-icon.svg" alt="">
          </button>
          <button v-else type="button" disabled><img src="@/assets/img/not-check-red-icon.svg" alt=""></button>
        </div>
      </template>
      <template #departure_location="{ row }">
        <span v-tooltip="{ content: row.transport.departure?.departure_location ? row.transport.departure.departure_location.name : '', placement: 'top-start', offset: 10, container: false }">
          {{ row.transport.departure?.departure_location ? row.transport.departure.departure_location.short_name : '-' }}
        </span>
      </template>
      <template #departure_notes="{ row }">
        {{ row.transport.departure?.departure_notes ? row.transport.departure.departure_notes : '-' }}
      </template>
      <template #controls="{ row }">
        <div v-if="!row.transfers.departure.length || row.transfers.departure[0]?.status?.code === 'cancelled'" class="table-default__controls">
          <button @click="onShowEditModal(row)" type="button">
            <img src="@/assets/img/edit-table-icon.svg" alt="Delete">
          </button>
        </div>
      </template>
    </v-client-table>
    <modal
      name="transport-modal"
      :width="774"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".modal-transport__title"
      :reset="true"
    >
      <div class="modal-transport">
        <button @click="onHideTransportModal" class="modal-transport__close" type="button"></button>
        <div class="modal-transport__top">
          <div class="modal-transport__title">
            <img :src="require(`@/assets/img/${getArrivalTypeModal}-icon.svg`)" alt="Arrival icon">
            <span>Departure details</span>
          </div>
          <app-checkbox
            v-model="form.departure_confirmed"
            label="Confirmed"
            v-tooltip="{ content: 'Checking this box will disable editing for client', placement: 'top-start', offset: 10, container: false }"
          />
          <app-checkbox
            v-show="form.departure_confirmed"
            v-model="form.departure_no_transfer"
            label="No transfer"
            @change.native="onChangeNoTransfer('departure')"
          />
          <app-select
            v-show="form.departure_confirmed && form.departure_no_transfer"
            v-model="form.departure_no_transfer_reason"
            :options="reasons_options"
            :clearable="false"
            placeholder="Choose reason"
            class="select--200"
            :error="$v.form.departure_no_transfer_reason.$error"
          />
        </div>
        <div class="modal-transport__row modal-transport__row--1">
          <app-form-group label="Transport mode" required>
            <app-select
              @input="onChangeTransportMethod"
              v-model="form.departure_method"
              :reduce="item => item.code"
              :options="transport_options"
              :filterable="false"
              :clearable="false"
              :searchable="false"
              :readonly="form.departure_confirmed"
              placeholder="Transport mode"
              :error="$v.form.departure_method.$error"
            />
            <template #error>
              <div v-if="$v.form.departure_method.$dirty && !$v.form.departure_method.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group label="Date" required>
            <app-date-picker
              v-model="form.departure_date"
              :readonly="form.departure_confirmed"
              placeholder="Date"
              :error="$v.form.departure_date.$error"
            />
            <template #error>
              <div v-if="$v.form.departure_date.$dirty && !$v.form.departure_date.required">Required field</div>
              <div v-if="$v.form.departure_date.$dirty && !$v.form.departure_date.minValue">
                Date cannot be less than the current date
              </div>
            </template>
          </app-form-group>
          <app-form-group label="Time" label-for="arrival-time" required>
            <app-input
              v-model="form.departure_time"
              v-mask="'99:99'"
              placeholder="Time"
              autocomplete="off"
              id="arrival-time"
              name="arrival_time"
              @paste.native.prevent
              :error="$v.form.departure_time.$error"
              :readonly="form.departure_confirmed"
            />
            <template #error>
              <div v-if="$v.form.departure_time.$dirty && !$v.form.departure_time.required">Required field</div>
              <div v-if="$v.form.departure_time.$dirty && !$v.form.departure_time.timeRegex">Wrong time</div>
            </template>
          </app-form-group>
          <app-form-group label="Location" required>
            <app-select
              @input="onDepartureLocationSelected"
              @search="onLocationSearch"
              v-model="form.departure_location"
              :options="location_options"
              :clearable="false"
              :readonly="form.departure_confirmed"
              placeholder="Location"
              :error="$v.form.departure_location.$error"
            />
            <template #error>
              <div v-if="$v.form.departure_location.$dirty && !$v.form.departure_location.required">Required field</div>
            </template>
          </app-form-group>
        </div>
        <div class="modal-transport__row modal-transport__row--2">
          <app-form-group
            v-show="form.departure_method === 'flight' || form.departure_method === 'bus'"
            :label="form.departure_method === 'flight' ? 'Airline' : 'Bus company'"
            required
          >
            <app-select
              v-model="form.departure_company"
              :reduce="item => item.id"
              :options="company_options.filter(item => item.type === form.departure_method)"
              :clearable="false"
              :readonly="form.departure_confirmed"
              placeholder="Company"
              :error="$v.form.departure_company.$error"
            />
            <template #error>
              <div v-if="$v.form.departure_company.$dirty && !$v.form.departure_company.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group v-show="form.departure_method === 'flight'" label="Flight number" label-for="arrival-flight" required>
            <app-input
              v-model="form.departure_flight_number"
              placeholder="Flight"
              id="arrival-flight"
              name="arrival_flight"
              :error="$v.form.departure_flight_number.$error"
              :readonly="form.departure_confirmed"
            />
            <template #error>
              <div v-if="$v.form.departure_flight_number.$dirty && !$v.form.departure_flight_number.required">
                Required field
              </div>
              <div v-if="$v.form.departure_flight_number.$dirty && !$v.form.departure_flight_number.flightNumberRegex">
                Only latin letters, numbers and '-' are allowed
              </div>
            </template>
          </app-form-group>
          <app-form-group v-show="form.departure_method === 'flight'" label="Domestic" class="form-group--switcher">
            <app-switcher v-model="form.departure_flight_domestic" :readonly="form.departure_confirmed" />
          </app-form-group>
        </div>
        <div class="modal-transport__row">
          <app-form-group label="Additional notes" label-for="arrival-notes">
            <app-input
                v-model="form.departure_notes"
                placeholder="Additional notes"
                id="arrival-notes"
                name="arrival_notes"
                :readonly="form.departure_confirmed"
            />
          </app-form-group>
        </div>
        <app-cells position="end">
          <app-button @click.native="onCheckForm" :disabled="$v.form.$error" ref="submitTransport">Save</app-button>
        </app-cells>
      </div>
    </modal>
    <modal
        name="transport-modal-edit"
        :width="774"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".modal-transport__title"
        :reset="true"
    >
      <div class="modal-transport">
        <button @click="$modal.hide('transport-modal-edit')" class="modal-transport__close" type="button"></button>
        <div class="modal-transport__top">
          <div class="modal-transport__title">
            <img :src="require(`@/assets/img/${getArrivalEditTypeModal}-icon.svg`)" alt="Arrival icon">
            <span>Departure details</span>
          </div>
          <app-checkbox
              v-model="form_edit.departure_confirmed"
              label="Confirmed"
              v-tooltip="{ content: 'Checking this box will disable editing for client', placement: 'top-start', offset: 10, container: false }"
          />
          <app-checkbox
              v-show="form_edit.departure_confirmed"
              v-model="form_edit.departure_no_transfer"
              label="No transfer"
              @change.native="onChangeNoTransfer('departure')"
          />
          <app-select
            v-show="form_edit.departure_confirmed && form_edit.departure_no_transfer"
            v-model="form_edit.departure_no_transfer_reason"
            :options="reasons_options"
            :clearable="false"
            placeholder="Choose reason"
            class="select--200"
            :error="$v.form_edit.departure_no_transfer_reason.$error"
          />
        </div>
        <div class="modal-transport__row modal-transport__row--1">
          <app-form-group label="Transport mode" required>
            <app-select
              @input="onChangeTransportMethod"
              v-model="form_edit.departure_method"
              :reduce="item => item.code"
              :options="transport_options"
              :filterable="false"
              :clearable="false"
              :searchable="false"
              placeholder="Transport mode"
              :readonly="form_edit.departure_confirmed"
              :error="$v.form_edit.departure_method.$error"
            />
            <template #error>
              <div v-if="$v.form_edit.departure_method.$dirty && !$v.form_edit.departure_method.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group label="Date" required>
            <app-date-picker
              v-model="form_edit.departure_date"
              :readonly="form_edit.departure_confirmed"
              placeholder="Date"
              :error="$v.form_edit.departure_date.$error"
            />
            <template #error>
              <div v-if="$v.form_edit.departure_date.$dirty && !$v.form_edit.departure_date.required">Required field</div>
              <div v-if="$v.form_edit.departure_date.$dirty && !$v.form_edit.departure_date.minValue">
                Date cannot be less than the current date
              </div>
            </template>
          </app-form-group>
          <app-form-group label="Time" label-for="arrival-time" required>
            <app-input
                v-model="form_edit.departure_time"
                v-mask="'99:99'"
                placeholder="Time"
                autocomplete="off"
                id="arrival-time"
                name="arrival_time"
                @paste.native.prevent
                :error="$v.form_edit.departure_time.$error"
                :readonly="form_edit.departure_confirmed"
            />
            <template #error>
              <div v-if="$v.form_edit.departure_time.$dirty && !$v.form_edit.departure_time.required">Required field</div>
              <div v-if="$v.form_edit.departure_time.$dirty && !$v.form_edit.departure_time.timeRegex">Wrong time</div>
            </template>
          </app-form-group>
          <app-form-group label="Location" required>
            <app-select
              @input="onDepartureEditLocationSelected"
              @search="onLocationSearch"
              v-model="form_edit.departure_location"
              :options="location_options"
              :clearable="false"
              :readonly="form_edit.departure_confirmed"
              placeholder="Location"
              :error="$v.form_edit.departure_location.$error"
            />
            <template #error>
              <div v-if="$v.form_edit.departure_location.$dirty && !$v.form_edit.departure_location.required">Required field</div>
            </template>
          </app-form-group>
        </div>
        <div class="modal-transport__row modal-transport__row--2">
          <app-form-group
              v-show="form_edit.departure_method === 'flight' || form_edit.departure_method === 'bus'"
              :label="form_edit.departure_method === 'flight' ? 'Airline' : 'Bus company'"
              required
          >
            <app-select
              v-model="form_edit.departure_company"
              :reduce="item => item.id"
              :options="company_options.filter(item => item.type === form_edit.departure_method)"
              :clearable="false"
              :readonly="form_edit.departure_confirmed"
              placeholder="Company"
              :error="$v.form_edit.departure_company.$error"
            />
            <template #error>
              <div v-if="$v.form_edit.departure_company.$dirty && !$v.form_edit.departure_company.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group v-show="form_edit.departure_method === 'flight'" label="Flight number" label-for="arrival-flight" required>
            <app-input
                v-model="form_edit.departure_flight_number"
                placeholder="Flight"
                id="arrival-flight"
                name="arrival_flight"
                :error="$v.form_edit.departure_flight_number.$error"
                :readonly="form_edit.departure_confirmed"
            />
            <template #error>
              <div v-if="$v.form_edit.departure_flight_number.$dirty && !$v.form_edit.departure_flight_number.required">
                Required field
              </div>
              <div v-if="$v.form_edit.departure_flight_number.$dirty && !$v.form_edit.departure_flight_number.flightNumberRegex">
                Only latin letters, numbers and '-' are allowed
              </div>
            </template>
          </app-form-group>
          <app-form-group v-show="form_edit.departure_method === 'flight'" label="Domestic" class="form-group--switcher">
            <app-switcher v-model="form_edit.departure_flight_domestic" :readonly="form_edit.departure_confirmed" />
          </app-form-group>
        </div>
        <div class="modal-transport__row">
          <app-form-group label="Additional notes" label-for="arrival-notes">
            <app-input
                v-model="form_edit.departure_notes"
                placeholder="Additional notes"
                id="arrival-notes"
                name="arrival_notes"
                :readonly="form_edit.departure_confirmed"
            />
          </app-form-group>
        </div>
        <app-cells position="end">
          <app-button @click.native="onCheckEditForm" :disabled="$v.form_edit.$error" ref="submitTransport">Save</app-button>
        </app-cells>
      </div>
    </modal>
    <modal
      name="create-transfer-modal"
      :width="500"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideCreateTransferModal" class="popup__close" type="button"></button>
        <div class="popup__title">Request departure transfer ({{ checked.length }} Pax)</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckTransferForm">
            <app-form-group label="Name" label-for="transfer_name" required>
              <app-input
                  v-model="transfer_form.name"
                  :error="$v.transfer_form.name.$error"
                  id="transfer_name"
                  placeholder="Name"
                  name="transfer_name"
              />
              <template #error>
                <div v-if="$v.transfer_form.name.$dirty && !$v.transfer_form.name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group>
              <app-checkbox
                  v-model="transfer_form.custom_pick_up"
                  label="Customize pick-up"
              />
            </app-form-group>
            <app-grid v-if="transfer_form.custom_pick_up">
              <template #item-1>
                <app-form-group label="Pick-up date" required>
                  <app-date-picker
                    v-model="transfer_form.pick_up_date"
                    placeholder="Specify a date"
                    :error="$v.transfer_form.pick_up_date.$error"
                  />
                  <template #error>
                    <div v-if="$v.transfer_form.pick_up_date.$dirty && !$v.transfer_form.pick_up_date.required">Required field</div>
                    <div v-if="$v.transfer_form.pick_up_date.$dirty && !$v.transfer_form.pick_up_date.minValue">
                      Date cannot be less than the current date
                    </div>
                  </template>
                </app-form-group>
              </template>
              <template #item-2>
                <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                  <app-input
                      v-model="transfer_form.pick_up_time"
                      v-mask="'99:99'"
                      placeholder="Time"
                      autocomplete="off"
                      id="pick_up_time-time"
                      name="pick_up_time"
                      @paste.native.prevent
                      :error="$v.transfer_form.pick_up_time.$error"
                  />
                  <template #error>
                    <div v-if="$v.transfer_form.pick_up_time.$dirty && !$v.transfer_form.pick_up_time.required">Required field</div>
                    <div v-if="$v.transfer_form.pick_up_time.$dirty && !$v.transfer_form.pick_up_time.timeRegex">Wrong time</div>
                  </template>
                </app-form-group>
              </template>
            </app-grid>
            <app-form-group label="Pick-up point" required>
              <app-select
                @input="onDeparturePickUpPointSelected"
                @search="onLocationSearch"
                v-model="transfer_form.pick_up_point"
                :options="location_options"
                :filterable="false"
                :clearable="false"
                placeholder="Select"
                :error="$v.transfer_form.pick_up_point.$error"
              />
              <template #error>
                <div v-if="$v.transfer_form.pick_up_point.$dirty && !$v.transfer_form.pick_up_point.required">Required field</div>
              </template>
            </app-form-group>
            <draggable
                :list="transfer_form.destination_list"
                v-bind="dragOptions"
                handle=".sortable__handle"
                class="transfer-sortable transfer-sortable--lite"
            >
              <transition-group type="transition" :name="'flip-list'" tag="div">
                <div v-for="(element, index) in transfer_form.destination_list" :key="`list_item_${index}`" class="transfer-sortable__item">
                  <div class="transfer-sortable__row">
                    <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                      <app-select
                        @input="onDepartureTransferLocationSelected(element.location, index)"
                        @search="onLocationSearch"
                        v-model="element.location"
                        :options="location_options"
                        :filterable="false"
                        :clearable="false"
                        placeholder="Select"
                        :error="$v.transfer_form.destination_list.$each[index].location.$error"
                      />
                      <template #error>
                        <div v-if="$v.transfer_form.destination_list.$each[index].location.$dirty && !$v.transfer_form.destination_list.$each[index].location.required">Required field</div>
                      </template>
                    </app-form-group>
                    <button class="transfer-sortable__btn sortable__handle">
                      <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                    </button>
                    <button
                        v-if="index !== 0"
                        @click="onRemoveDestination(index)"
                        class="transfer-sortable__close"
                    >
                      <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                    </button>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <app-cells>
              <app-button @click.native="onAddDestination">
                <img src="@/assets/img/plus-icon.svg" alt="Add">
                <span>Add destination</span>
              </app-button>
            </app-cells>
            <app-form-group label="Notes" label-for="notes">
              <app-textarea
                  v-model="transfer_form.notes"
                  id="notes"
                  placeholder="Notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Create transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="transfer-modal"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup popup--padding-sm">
        <button @click="$modal.hide('transfer-modal')" class="popup__close" type="button"></button>
        <div class="popup__title"><span>Transfer</span></div>
        <div class="popup__body">
          <div class="popup__activities">
            <div
              v-for="activity of transfer_data"
              :key="activity.id"
              class="popup__activity"
            >
              <div class="popup__activity-info">
                <div class="popup__activity-row popup__activity-row--double">
                  <div class="popup__activity-values">
                    <span>Pick-up date:</span>
                    <span>{{ dateFormat(activity.pick_up_date) }} {{ activity.pick_up_time }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Pick-up point:</span>
                    <span>{{ activity.pick_up_point?.short_name }}</span>
                  </div>
                </div>
                <div class="popup__block-route popup__activity-row">
                  <span class="popup__activity-key">Points:</span>
                  <span>{{ activity.pick_up_point.short_name }}</span>
                  <img src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                  <span v-for="(point, index) in activity.points" :key="point.id" class="popup__block-route-group">
                      <span>{{ point.location.short_name }}</span>
                      <img v-if="index !== activity.points.length - 1" src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                    </span>
                </div>
                <div class="popup__activity-row popup__activity-row--single">
                  <div class="popup__activity-values popup__activity-values--center">
                    <span>Status:</span>
                    <span
                      class="status-tag"
                      :style="{ 'backgroundColor': activity.status.code === 'need_amended' || activity.status.code === 'requested' ? '#eec82d' : activity.status.code === 'arranged' ? '#77b017' : '#bcbcbc', 'color': '#fff' }"
                    >
                        {{ activity.status.name }}
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div class="flying-block flying-block--column" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected clients: <span>{{ checked.length }}</span></div>
      <div class="flying-block__holder">
        <app-button @click.native="onShowTransportModal">Update departure</app-button>
        <app-button @click.native="onShowCreateTransferModal">Request transfer</app-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getArrivalCompanies,
  getArrivalMethods,
  getClients,
  getGoogleSearch,
  getReasonsNoTransfers,
  patchClients,
  postClientsGroupsClientsTransport,
  postLocation,
  postTransferDeparture,
} from '@/http'
import { format, parse } from 'date-fns'
import axios from 'axios'
import { helpers, required, requiredIf } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
import draggable from 'vuedraggable'

const flightNumberRegex = helpers.regex('flightNumberRegex', /^[a-zA-Z0-9-]*$/i)
const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'ClientsGroupsDeparture',
  components: { draggable },
  props: {
    groupData: Object,
  },
  data() {
    return {
      page_loaded: false,
      table: {
        items: [],
        columns: ['full_name', 'transfers', 'departure_method', 'departure_date', 'departure_company', 'departure_flight_number', 'departure_ticket', 'departure_location', 'departure_notes'],
        options: {
          headings: {
            select: '',
            full_name: 'Full name',
            transfers: 'Transfer',
            departure_method: 'Transport mode',
            departure_date: 'Date',
            departure_company: 'Company',
            departure_flight_number: 'Flight number',
            departure_ticket: 'Tickets',
            departure_location: 'Location',
            departure_notes: 'Notes',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      form: {
        departure_company: '',
      },
      form_edit: {
        departure_company: '',
      },
      transport_options: [],
      location_options: [],
      pickup_location_options: [],
      company_options: [],
      transfer_form: {
        destination_list: [ { location: null } ],
        custom_pick_up: false
      },
      transfer_data: [],
      reasons_options: [],
    }
  },
  validations: {
    form: {
      departure_method: { required },
      departure_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      departure_time: {
        required,
        timeRegex
      },
      departure_company: {
        required: requiredIf(function() {
          return this.form.departure_method === 'flight' || this.form.departure_method === 'bus'
        })
      },
      departure_flight_number: {
        required: requiredIf(function() {
          return this.form.departure_method === 'flight'
        }),
        flightNumberRegex
      },
      departure_location: { required },
      departure_no_transfer_reason: {
        required: requiredIf(function() {
          return this.form.departure_no_transfer
        })
      }
    },
    form_edit: {
      departure_method: { required },
      departure_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      departure_time: {
        required,
        timeRegex
      },
      departure_company: {
        required: requiredIf(function() {
          return this.form.departure_method === 'flight' || this.form.departure_method === 'bus'
        })
      },
      departure_flight_number: {
        required: requiredIf(function() {
          return this.form.departure_method === 'flight'
        }),
        flightNumberRegex
      },
      departure_location: { required },
      departure_no_transfer_reason: {
        required: requiredIf(function() {
          return this.form.departure_no_transfer
        })
      }
    },
    transfer_form: {
      name: { required },
      pick_up_date: {
        required: requiredIf(function() {
          return this.transfer_form.custom_pick_up
        }),
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: {
        required: requiredIf(function() {
          return this.transfer_form.custom_pick_up
        }),
        timeRegex
      },
      pick_up_point: { required },
      destination_list: {
        $each: {
          location: { required },
        }
      },
    }
  },
  computed: {
    getArrivalTypeModal() {
      return this.form.departure_method || 'unknown'
    },
    getArrivalEditTypeModal() {
      if (this.form_edit.departure_method) return this.form_edit.departure_method || 'unknown'
      else return 'unknown'
    },
    is_show_checkbox() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('support')
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'destination',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table.items.forEach(item => {
          if (!this.checked.includes(item.id)) this.checked.push(item.id)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  created() {
    if (this.is_show_checkbox) this.table.columns.unshift('select')
    if (this.is_show_checkbox) this.table.columns.push('controls')
    this.fetchItems()
    getArrivalMethods()
      .then(response => {
        this.transport_options = response.data
      })
    getArrivalCompanies()
      .then(response => {
        this.company_options = response.data
      })
    this.transfer_form.name = this.groupData.name
    getReasonsNoTransfers().then(response => { this.reasons_options = response.data })
  },
  methods: {
    onCheckEditForm() {
      this.$v.form_edit.$touch()
      if (this.$v.form_edit.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendEditForm()
      }
    },
    sendEditForm() {
      this.$refs.submitTransport.preload = true
      patchClients(this.form_edit.client_id, this.normalizeEditForm())
        .finally(() => { this.$refs.submitTransport.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Arrival changed',
          })
          this.fetchItems()
          this.$modal.hide('transport-modal-edit')
          this.form_edit = {
            arrival_company: '',
          }
          this.$v.form_edit.$reset()
        })
    },
    normalizeEditForm() {
      const form = {...this.form_edit}
      if (form.departure_method !== 'flight') {
        form.departure_flight_number = null
        form.departure_flight_domestic = false
      }
      if (form.departure_method !== 'flight' && form.departure_method !== 'bus') form.departure_company = null
      if (form.departure_company && typeof form.departure_company === 'object') form.departure_company = form.departure_company.id
      form.departure_location = form.departure_location.id
      if (form.departure_no_transfer_reason) form.departure_no_transfer_reason = form.departure_no_transfer_reason.code
      if (!form.departure_confirmed) {
        form.departure_no_transfer = false
        form.departure_no_transfer_reason = null
      }
      if (form.departure_ticket && form.departure_ticket.file) form.departure_ticket = form.departure_ticket.id

      return { ...form }
    },
    onShowEditModal(row) {
      this.form_edit = row.transport.departure
      this.form_edit.client_id = row.id
      if (this.form_edit.departure_method) this.form_edit.departure_method = this.form_edit.departure_method.code
      this.$modal.show('transport-modal-edit')
    },
    onShowTransportModal() {
      this.$modal.show('transport-modal')
      this.is_show_flying_block = false
    },
    onHideTransportModal() {
      this.$modal.hide('transport-modal')
      this.is_show_flying_block = true
    },
    onShowCreateTransferModal() {
      this.transfer_form.custom_pick_up = false
      this.$modal.show('create-transfer-modal')
      this.is_show_flying_block = false
    },
    onHideCreateTransferModal() {
      this.$modal.hide('create-transfer-modal')
      this.is_show_flying_block = true
    },
    onChangeNoTransfer() {
      if (!this.form.departure_no_transfer) this.form.departure_no_transfer_reason = null
    },
    onAddDestination() {
      this.transfer_form.destination_list.push({ location: null })
      this.$v.transfer_form.destination_list.$touch()
    },
    onRemoveDestination(index) {
      this.transfer_form.destination_list.splice(index, 1)
      this.$v.transfer_form.destination_list.$touch()
    },
    onDeparturePickUpPointSelected({ name, place_id }) {
      this.$refs.submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.transfer_form.pick_up_point = res.data
        this.$refs.submit.preload = false
      })
    },
    onDepartureTransferLocationSelected({ name, place_id }, index) {
      this.$refs.submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.transfer_form.destination_list[index].location = res.data
        this.$refs.submit.preload = false
      })
    },
    onDepartureLocationSelected({ name, place_id }) {
      this.$refs.submitTransport.preload = true
      postLocation({ name, place_id }).then(res => {
        this.form.departure_location = res.data
        this.$refs.submitTransport.preload = false
      })
    },
    onDepartureEditLocationSelected({ name, place_id }) {
      this.$refs.submitTransport.preload = true
      postLocation({ name, place_id }).then(res => {
        this.form_edit.departure_location = res.data
        this.$refs.submitTransport.preload = false
      })
    },
    onShowTransfersModal(data) {
      this.transfer_data = data
      this.$modal.show('transfer-modal')
    },
    fetchItems() {
      this.page_loaded = false
      getClients({ group: this.$route.params.id, ordering: 'departure' })
        .then(res => { this.table.items = res.data })
        .finally(() => { this.page_loaded = true })
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    onDownloadTicket(data) {
      axios.get(data.departure_ticket.file, { responseType: 'blob' })
        .then(response => {
          const url = URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = data.departure_ticket.file_name.split('.').pop()
          link.href = url
          link.setAttribute('download', `Tickets ${data.full_name}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
    onChangeTransportMethod() {
      this.form.departure_company = ''
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submitTransport.preload = true
      postClientsGroupsClientsTransport(this.$route.params.id, this.normalizeForm())
        .finally(() => { this.$refs.submitTransport.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Departure changed',
          })
          this.fetchItems()
          this.checked = []
          this.$modal.hide('transport-modal')
          this.form = {
            departure_company: '',
          }
          this.$v.form.$reset()
        })
    },
    onCheckTransferForm() {
      this.$v.transfer_form.$touch()
      if (this.$v.transfer_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendTransferForm()
      }
    },
    sendTransferForm() {
      this.$refs.submit.preload = true
      const data = {
        ...this.transfer_form,
        clients: this.checked,
        pick_up_point: this.transfer_form.pick_up_point.id,
        points: this.transfer_form.destination_list.map((item, index) => ({ location: item.location.id, sort: index }))
      }
      if (this.transfer_form.custom_pick_up) {
        delete this.transfer_form.pick_up_date
        delete this.transfer_form.pick_up_time
      }
      postTransferDeparture(data)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer created',
          })
          this.fetchItems()
          this.checked = []
          this.$modal.hide('create-transfer-modal')
          this.transfer_form = { destination_list: [ { location: null } ] }
          this.transfer_form.name = this.groupData.name
          this.$v.transfer_form.$reset()
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    normalizeForm() {
      const form = {...this.form}
      if (form.departure_method !== 'flight') {
        form.departure_flight_number = null
        form.departure_flight_domestic = false
      }
      if (form.departure_method !== 'flight' && form.departure_method !== 'bus') form.departure_company = null
      if (form.departure_company && typeof form.departure_company === 'object') form.departure_company = form.departure_company.id
      form.departure_location = form.departure_location.id
      if (form.departure_no_transfer_reason) form.departure_no_transfer_reason = form.departure_no_transfer_reason.code
      if (!form.departure_confirmed) {
        form.departure_no_transfer = false
        form.departure_no_transfer_reason = null
      }

      return {...form, clients: this.checked}
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          loading(false)
          vm.location_options = response.data
        })
      }
    }, 350),
  }
}
</script>
